import logo from "./logo.svg";
import "./App.css";
import Home from "./components/home/Home";
import "./styles/mixins/global.scss";
import { Route, BrowserRouter as Router } from "react-router-dom";
import AboutUs from "./components/AboutUs/AboutUs";
import UrbanRegenration from "./components/UrbanRegenration/UrbanRegenration";
import Expertise from "./components/Expertise/Expertise";
import Contact from "./components/Contact/Contact";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NewsDetails from "./components/NewsDetails/NewsDetails";
import Disclaimer from "./components/Disclaimer/Disclaimer";
import PoliciesAndDisclosures from "./components/PoliciesAndDisclosures/PoliciesAndDisclosures";
import WhistleblowingPolicy from "./components/WhistleblowingPolicy/WhistleblowingPolicy";
import ResponsibleInvestmentPolicy from "./components/ResponsibleInvestmentPolicy/ResponsibleInvestmentPolicy";
import PoliticalEngagementPolicy from "./components/PoliticalEngagementPolicy/PoliticalEngagementPolicy";
import Cookies from "./components/Cookies/Cookies";
import NewsAndInsights from "./components/NewsAndInsights/NewsAndInsights";
import Sfdr from "./components/SFDR/Sfdr";
import PAIStatement from "./components/PAI-2023/Sfdr";
import PAIStatement2024 from "./components/PAI-2024/Sfdr";
import PAIStatements from "./components/PAIStatements/PAIStatements";
import { mainLinksUrls, secondaryLinks } from "./constants/links";
import ModernSlaveryStatement from "./components/ModernSlaveryStatement/ModernSlaveryStatement";

function App() {
	return (
		<>
			<Router>
				{/* <Header/> */}
				<>
					<Cookies />
				</>
				<Route
					exact
					path="/"
					component={Home}
				/>
				<Route
					exact
					path={mainLinksUrls.about}
					component={AboutUs}
				/>
				<Route
					exact
					path={mainLinksUrls.esg}
					component={UrbanRegenration}
				/>
				{/* <Route exact path={secondaryLinks.sustainability} component={Sustainability} /> */}
				<Route
					exact
					path={mainLinksUrls.expertiseAndFund}
					component={Expertise}
				/>
				<Route
					exact
					path={mainLinksUrls.contact}
					component={Contact}
				/>
				{/* <Route exact path={secondaryLinks.community} component={CommunityPage} /> */}
				{/* <Route exact path={secondaryLinks.technology} component={TechnologyPage} />
        <Route exact path={secondaryLinks.wellbeing} component={Wellbeing} />
        <Route exact path={secondaryLinks.scale} component={Scale} /> */}
				<Route
					exact
					path="/newsdetails"
					component={NewsDetails}
				/>
				<Route
					exact
					path="/policies-and-disclosures"
					component={PoliciesAndDisclosures}
				/>
				<Route
					exact
					path="/disclaimer-policy"
					component={Disclaimer}
				/>
				<Route
					exact
					path="/whistleblowing-policy"
					component={WhistleblowingPolicy}
				/>
				<Route
					exact
					path="/political-engagement-policy"
					component={PoliticalEngagementPolicy}
				/>
				<Route
					exact
					path="/responsible-investment-policy"
					component={ResponsibleInvestmentPolicy}
				/>
				<Route
					exact
					path="/news-insights"
					component={NewsAndInsights}
				/>
				<Route
					exact
					path="/sfdr-disclosure"
					component={Sfdr}
				/>

				<Route
					exact
					path="/pai-statement"
					component={PAIStatements}
				/>

				<Route
					exact
					path="/pai-statement-2024"
					component={PAIStatement2024}
				/>
				<Route
					exact
					path="/pai-statement-2023"
					component={PAIStatement}
				/>
				<Route
					exact
					path="/modern-slavery-statement"
					component={ModernSlaveryStatement}
				/>
			</Router>
		</>
	);
}

export default App;
